// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sensorsListBody__OLdlx {
  height: 100%;
  padding: 25px;
  background-color: var(--tables-main-surface);
}
@media (max-width: 810px) {
  .sensorsListBody__OLdlx {
    padding: 15px;
  }
}

.bodyExtraPanelInfo__IpkeK {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  flex-wrap: wrap;
  row-gap: 15px;
}

.bodyExtraPanel__XZ2mx {
  display: flex;
  flex-direction: column;
  gap: 25px;
  padding: 15px 25px;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-primary-row-surface-default);
  box-shadow: var(--info-block-box-shadow);
}

.bodyExtraPanelTitle__j_Txx {
  font-size: 11px;
  line-height: 12px;
  text-transform: uppercase;
  color: var(--title-inputs-sections-title);
}

.bodyExtraPanelSubtitle__DRGB5 {
  font-size: 18px;
  line-height: 20px;
  font-weight: 500;
  color: var(--tables-primary-row-text-main);
  margin-top: 5px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: 25px;
  row-gap: 15px;
}

.nameBlock__Jup0X {
  display: flex;
  align-items: center;
}
.nameBlock__Jup0X svg {
  transition: transform 250ms ease;
}

.collapseIcon__b8V2c {
  cursor: pointer;
  transform: rotate(180deg);
}

.hideCollapseIcon__T5jME {
  transform: rotate(0deg);
}

.pointName__knkf5 {
  margin-right: 10px;
  padding-top: 7.5px;
  padding-bottom: 7.5px;
}

.bodyExtraPanelLeft__rP6_r {
  width: 100%;
  max-width: 640px;
}

.bodyExtraPanelRight__oqku_ {
  min-width: 320px;
  flex-wrap: wrap;
}
@media print {
  .bodyExtraPanelRight__oqku_ {
    display: none;
  }
}

.bodyMainPanel__q0Khx {
  box-shadow: var(--info-block-box-shadow);
}

.equipmentNameSkeleton__z_7Xv {
  width: 100%;
  max-width: 640px;
  height: 35px;
  margin-top: 5px;
}`, "",{"version":3,"sources":["webpack://./../src/pages/SensorsList/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,aAAA;EACA,4CAAA;AAzEF;AA2EE;EALF;IAMI,aAAA;EAxEF;AACF;;AA2EA;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;EACA,eAAA;EACA,aAAA;AAxEF;;AA2EA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;EACA,yDAAA;EACA,qDAAA;EACA,wCAAA;AAxEF;;AA2EA;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,yCAAA;AAxEF;;AA2EA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,0CAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;AAxEF;;AA2EA;EACE,aAAA;EACA,mBAAA;AAxEF;AA0EE;EACE,gCAAA;AAxEJ;;AA4EA;EACE,eAAA;EACA,yBAAA;AAzEF;;AA4EA;EACE,uBAAA;AAzEF;;AA4EA;EACE,kBAAA;EACA,kBAAA;EACA,qBAAA;AAzEF;;AA4EA;EACE,WAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,gBAAA;EACA,eAAA;AAzEF;AA2EE;EAJF;IAKI,aAAA;EAxEF;AACF;;AA2EA;EACE,wCAAA;AAxEF;;AA2EA;EACE,WAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AAxEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.sensorsListBody {\n  height: 100%;\n  padding: 25px;\n  background-color: var(--tables-main-surface);\n\n  @media (max-width: 810px) {\n    padding: 15px;\n  }\n}\n\n.bodyExtraPanelInfo {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  flex-wrap: wrap;\n  row-gap: 15px;\n}\n\n.bodyExtraPanel {\n  display: flex;\n  flex-direction: column;\n  gap: 25px;\n  padding: 15px 25px;\n  border-bottom: 1px solid var(--tables-primary-row-stroke);\n  background: var(--tables-primary-row-surface-default);\n  box-shadow: var(--info-block-box-shadow);\n}\n\n.bodyExtraPanelTitle {\n  font-size: 11px;\n  line-height: 12px;\n  text-transform: uppercase;\n  color: var(--title-inputs-sections-title);\n}\n\n.bodyExtraPanelSubtitle {\n  font-size: 18px;\n  line-height: 20px;\n  font-weight: 500;\n  color: var(--tables-primary-row-text-main);\n  margin-top: 5px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  column-gap: 25px;\n  row-gap: 15px;\n}\n\n.nameBlock {\n  display: flex;\n  align-items: center;\n\n  & svg {\n    transition: transform 250ms ease;\n  }\n}\n\n.collapseIcon {\n  cursor: pointer;\n  transform: rotate(180deg);\n}\n\n.hideCollapseIcon {\n  transform: rotate(0deg);\n}\n\n.pointName {\n  margin-right: 10px;\n  padding-top: 7.5px;\n  padding-bottom: 7.5px;\n}\n\n.bodyExtraPanelLeft {\n  width: 100%;\n  max-width: 640px;\n}\n\n.bodyExtraPanelRight {\n  min-width: 320px;\n  flex-wrap: wrap;\n\n  @media print {\n    display: none;\n  }\n}\n\n.bodyMainPanel {\n  box-shadow: var(--info-block-box-shadow);\n}\n\n.equipmentNameSkeleton {\n  width: 100%;\n  max-width: 640px;\n  height: 35px;\n  margin-top: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sensorsListBody": `sensorsListBody__OLdlx`,
	"bodyExtraPanelInfo": `bodyExtraPanelInfo__IpkeK`,
	"bodyExtraPanel": `bodyExtraPanel__XZ2mx`,
	"bodyExtraPanelTitle": `bodyExtraPanelTitle__j_Txx`,
	"bodyExtraPanelSubtitle": `bodyExtraPanelSubtitle__DRGB5`,
	"nameBlock": `nameBlock__Jup0X`,
	"collapseIcon": `collapseIcon__b8V2c`,
	"hideCollapseIcon": `hideCollapseIcon__T5jME`,
	"pointName": `pointName__knkf5`,
	"bodyExtraPanelLeft": `bodyExtraPanelLeft__rP6_r`,
	"bodyExtraPanelRight": `bodyExtraPanelRight__oqku_`,
	"bodyMainPanel": `bodyMainPanel__q0Khx`,
	"equipmentNameSkeleton": `equipmentNameSkeleton__z_7Xv`
};
module.exports = ___CSS_LOADER_EXPORT___;
